(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/cart-notification
 * -----------------------------------------------------------------------------
 * @version 0.0.3
 * @overview Cart notification popup.
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
*/ if (customElements.get("cart-notification") === undefined) {
    class CartNotification extends HTMLElement {
        constructor(){
            super();
            this.showOnItemAddedEvent = true;
            this.close = this.close.bind(this);
            this.trapFocus = this.trapFocus.bind(this);
            this.keyEvents = this.keyEvents.bind(this);
            this.clickEvents = this.clickEvents.bind(this);
            document.addEventListener("cart:updated", this.cartUpdated.bind(this));
        }
        cartUpdated(event) {
            if (!event.detail) return;
            if (event.detail.type === "added") this.itemAdded();
            if (event.detail.type === "removed") this.itemRemoved();
            if (event.detail.type === "updated") this.itemUpdated();
        }
        itemAdded() {
            fetch(`?section_id=${this.dataset.section}`).then((response)=>response.text()).then((responseText)=>{
                const targetElement = this.localName;
                const html = new DOMParser().parseFromString(responseText, "text/html");
                const destination = document.querySelector(targetElement);
                const source = html.querySelector(targetElement);
                if (source && destination) destination.innerHTML = source.innerHTML;
                setTimeout(()=>{
                    this.open();
                }, 50);
            });
        }
        itemRemoved() {
        // console.log('Item removed')
        // TODO
        }
        itemUpdated() {
        // console.log('Item updated')
        // TODO
        }
        open() {
            this.cachedActiveElement = document.activeElement;
            this.removeAttribute("hidden");
            this.querySelectorAll("[tabindex]").forEach((item)=>item.setAttribute("tabindex", 0));
            this.addEventListener("transitionend", this.setFocus);
            document.addEventListener("focusout", this.trapFocus);
            document.addEventListener("keyup", this.keyEvents);
            document.addEventListener("click", this.clickEvents);
            if (Shopify.designMode) return;
            setTimeout(()=>{
                this.close();
            }, 5000);
        }
        close() {
            this.setAttribute("hidden", "");
            this.querySelectorAll("[tabindex]").forEach((item)=>item.setAttribute("tabindex", -1));
            document.removeEventListener("focusout", this.trapFocus);
            document.removeEventListener("keyup", this.keyEvents);
            document.removeEventListener("click", this.clickEvents);
            this.cachedActiveElement.focus();
        }
        setFocus() {
            this.querySelectorAll("[tabindex]")[0]?.focus();
            this.removeEventListener("transitionend", this.setFocus);
        }
        trapFocus(event) {
            if (this.contains(event.relatedTarget)) return;
            this.querySelectorAll('button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])')[0].focus();
        }
        keyEvents(event) {
            if (event.code === "Escape") this.close();
        }
        clickEvents(event) {
            if (event.target.closest('[name="close"]') || !this.contains(event.target)) this.close();
        }
    }
    customElements.define("cart-notification", CartNotification);
}



})();
